module.exports = __webpack_public_path__ + "img/茯苓.1ff0b2a0.jpg";